<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar text-center>
      <ion-title>{{paramObject.modalHeaderText}}</ion-title>
    </ion-toolbar>
  </ion-header>

  <div padding>
    <form [formGroup]="registrationForm">
      <div *ngIf="paramObject.modalType == 'Input'" text-center>
        <ion-card>
          <!-- <div formGroupName="personalDetails"> -->
          <ion-card-header class="ion-card-header">
            <ion-card-title
              [ngClass]="{'ion-card-expanded': isExpanded('Personal Details') }"
              (click)="expandAccordion($event)"
              >Personal Details
            </ion-card-title>
          </ion-card-header>
          <ion-card-content
            [ngClass]="{'ion-card-collapsed': !isExpanded('Personal Details') }"
          >
            <ion-item>
              <ion-label>Firstname : </ion-label>
              <ion-input
                [(ngModel)]="registration.FirstName"
                formControlName="FirstName"
              >
              </ion-input>
            </ion-item>
            <ion-item>
              <ion-label>Surname : </ion-label>
              <ion-input
                [(ngModel)]="registration.Surname"
                formControlName="Surname"
              ></ion-input>
            </ion-item>
            <ion-item>
              <ion-label>ID : </ion-label>
              <ion-input
                [(ngModel)]="registration.ID"
                formControlName="ID"
              ></ion-input>
            </ion-item>
            <ion-item>
              <ion-label>Cellphone no : </ion-label>
              <ion-input
                [(ngModel)]="registration.Cellno"
                formControlName="Cellno"
              ></ion-input>
            </ion-item>
            <ion-item>
              <ion-label>Email : </ion-label>
              <ion-input
                [(ngModel)]="registration.Email"
                formControlName="Email"
              ></ion-input>
            </ion-item>
          </ion-card-content>
        </ion-card>

        <ion-card>
          <ion-card-header class="ion-card-header">
            <ion-card-title
              [ngClass]="{'ion-card-expanded': isExpanded('Login credentials') }"
              (click)="expandAccordion($event)"
              >Login credentials
            </ion-card-title>
          </ion-card-header>
          <ion-card-content
            [ngClass]="{'ion-card-collapsed': !isExpanded('Login credentials') }"
          >
            <!-- <div formGroupName="loginDetails"> -->
            <ion-item>
              <ion-label>Username : </ion-label>
              <ion-input
                [(ngModel)]="registration.Username"
                formControlName="Username"
              ></ion-input>
            </ion-item>
            <ion-item>
              <ion-label>Password : </ion-label>
              <ion-input
                [(ngModel)]="registration.Password"
                formControlName="Password"
              ></ion-input>
            </ion-item>
          </ion-card-content>
        </ion-card>

        <ion-card>
          <ion-card-header class="ion-card-header">
            <ion-card-title
              [ngClass]="{'ion-card-expanded': isExpanded('Company details') }"
              (click)="expandAccordion($event)"
              >Company details
            </ion-card-title>
          </ion-card-header>
          <ion-card-content
            [ngClass]="{'ion-card-collapsed': !isExpanded('Company details') }"
          >
            <!-- <div formGroupName="companyDetails"> -->
            <ion-item>
              <ion-label>Company name : </ion-label>
              <ion-input
                [(ngModel)]="registration.CompanyName"
                formControlName="CompanyName"
              >
              </ion-input>
            </ion-item>
            <ion-item>
              <ion-label>Company registration no : </ion-label>
              <ion-input
                [(ngModel)]="registration.CompanyRegNo"
                formControlName="CompanyRegNo"
              >
              </ion-input>
            </ion-item>
            <ion-item>
              <ion-label>Company vat no : </ion-label>
              <ion-input
                [(ngModel)]="registration.CompanyVatNo"
                formControlName="CompanyVatNo"
              >
              </ion-input>
            </ion-item>
          </ion-card-content>
        </ion-card>

        <ion-button (click)="onRegister()" class="menuitem-ion-button"
          >Register</ion-button
        >
      </div>
    </form>
  </div>
</ion-content>
